import { use } from 'react';

import { UserContext, UserContextValue } from '../contexts/user-context';

export const useUser = (): UserContextValue => {
   const context = use(UserContext);

   if (!context) {
      throw new Error('useUser must be used within a UserProvider');
   }

   return context;
};
